import React, {Component} from 'react';
import { connect } from "react-redux";
import axios from "axios";
import FormTemplate from "../common/form/FormTemplate";
import { setSelectedControlPanelType, CountyEfileControlPanelKey } from "../../redux/actions/controlPanelActions";

import configData from "../../config/config.json";
import { handleError } from '../../redux/actions/commonStuff';
import { LOADING_STATUES } from "../constants/constants";
import Alert from '../common/modal/Alert';
import { ALERT_TYPES } from "../constants/constants";

const componentName = CountyEfileControlPanelKey;

const matchDispatchToProps = (dispatch) => {
  return { 
    setSelectedControlPanelType: () => dispatch(setSelectedControlPanelType(componentName))
  }
}

/**
 * The county efile settings.
 */
class CountyEfile extends Component {

  state = {
    efileCountyNote: "",
    acknowledgement: false,
    acknowledgementStatement: "",
    message:"",
    showAlert: false,
    alertMessage: "",
    documentNote: '',
    helperDocumentNote: ''
  }

  showAlert = (alertMessage) => {
		this.setState({
		  showAlert: true,
		  alertMessage
		})
	  }
	
	hideAlert = () => {
		this.setState({
			showAlert: false,
			alertMessage: ""
		})
	}

  handleSubmit = (event) => {
    event.preventDefault();
  
    if (this.state.status === "") {
      this.setState({
        status: LOADING_STATUES.LOADING,
        message: ""
      })
    } else {
      return;
    }

    axios.post(configData.LANDSHARK_SERVER_URL + "controlPanel/countyConfig/countyEfile", this.state, { withCredentials: true })
    .then(
      (response) => {
        this.setState({ 
          status: LOADING_STATUES.SUCCESS
        });
      },
      (error) => {
        handleError(error, this.props.history);
      }
    );
  }

  handleChange = (event) => {
    let value = event.target.value;
    value = value === "true" || value === "false" ? JSON.parse(event.target.value) : value;
    this.setState({
      status: "",
      message: "",
      [event.target.id]: value ? value : (event.target.type === 'number' ? 0 : value)
    })
  }

  componentDidMount() {
    this.props.setSelectedControlPanelType();
    
    axios.get(configData.LANDSHARK_SERVER_URL + "controlPanel/countyConfig/countyEfile", { withCredentials: true })
    .then(
      (response) => {
        const content = response.data.content;
        this.setState( {
          efileCountyNote: content.efileCountyNote,
          acknowledgement: content.acknowledgement,
          acknowledgementStatement: content.acknowledgementStatement,
          status : "",
          documentNote: content.documentNote,
          helperDocumentNote: content.helperDocumentNote
        });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  render() {

    const formProps = {
      componentName: componentName,
      pageHeading: "E File",
      onChange: this.handleChange,
      onSubmit: this.handleSubmit,
      successIndicator: this.state.status === LOADING_STATUES.SUCCESS,
      loadingIndicator: this.state.status === LOADING_STATUES.LOADING,
      message: this.state.message,
      formGroupRows: [
        {
          formGroups: [
            { id: 'efileCountyNote', label: 'County Note', fieldType: 'text', value: this.state.efileCountyNote, lgSize: 10 }
          ]
        },
        {
          formGroups: [
            { id: 'documentNote', label: 'Document Note', fieldType: 'text', value: this.state.documentNote, lgSize: 10 }
          ]
        },
        {
          formGroups: [
            { id: 'helperDocumentNote', label: 'Additional Information Note', fieldType: 'text', value: this.state.helperDocumentNote, lgSize: 10 }
          ]
        },
        {
          formGroups: [
            { id: 'acknowledgement', label: 'Acknowledge', fieldType: 'select', style: { minWidth: '10rem' }, value: this.state.acknowledgement }
          ]
        },
        {
          formGroups: [
            { id: 'acknowledgementStatement', label: 'Acknowledgement Statement', fieldType: 'text', value: this.state.acknowledgementStatement, lgSize: 10 }]
        }
      ]
    }


    return (
      <>
        <FormTemplate {...formProps} />
				<Alert show={this.state.showAlert} hideAlert={this.hideAlert} message={this.state.alertMessage} />
      </>
    );
  }
}

export default connect(null, matchDispatchToProps)(CountyEfile);